export default "__VITE_ASSET__CZyGI$Ro__"